import { useDateFormat } from '@vueuse/core';
import i18n from '@/app/lang/i18n.js';
import { unref } from 'vue';
import datesConfig from '@/app/config/dates.js';

export const formatDate = (date, format = 'DD-MM-YYYY') => {
    let locale = 'nl-NL';

    switch (i18n.global.locale.value) {
        case 'en':
            locale = 'en-US';
            break;
    }

    return unref(useDateFormat(date, format, { locales: locale }));
};

export const isHoliday = (day, month) =>
    datesConfig.holidays.some(([hDay, hMonth]) => hDay === day && hMonth === month + 1);

export const isWeekday = (weekday) => ![0, 6].includes(weekday);
